<template>
  <div class="KidsForm border m-2 p-2">
    <h3>{{ $t('form.kids.block_name') }}</h3>
    <div v-if="loaded">
      <!--
      <div v-if="autoSave && !hasData">
        <div v-if="allValid" class="alert alert-success" role="alert">
          {{ $t('form.kids.all_valid') }}
        </div>
        <div v-else class="alert alert-notice" role="alert">
          {{ $t('form.kids.not_valid') }}
        </div>
      </div>
      -->
      <form>
        <div v-for="(kid, i) in kids" :key="i">
          <h4 v-if="kids.length > 1">
            <span>{{ $t('form.kids.kid_heading', { cnt: i + 1 }) }}</span>
            <a v-if="kidValid(kid)"
              style="margin-left:80%;cursor:pointer;"
              @click.prevent="removeKid(i)">
              {{ $t('form.kids.btn_remove_kid') }}
            </a>
          </h4>

          <BirthdateField v-model="kid.birthdate" type="kid" :error="birthdateError(kid)" v-if="loaded" :key="i" v-on:input="trySave" :class="{ hasError: showErrors && !kid.birthdate }"/>

          <div class="form-row">
            <div class="form-item form-item-20" :class="{ hasError: showErrors && ( isRequiredByAge(kid) && !kid.sex) }">
              <label>{{ $t('form.kids.fld_sex') }}<span v-if="isRequiredByAge(kid)" style="display:inline;"> *</span></label>
              <select :name="'kids.sex_' + i"
                v-model="kid.sex" v-on:blur="trySave()" :required="isRequiredByAge(i)">
                <option disabled value='null'>{{ $t('form.kids.fld_sex_option_null') }}</option>
                <option value="f">{{ $t('form.kids.fld_sex_option_f') }}</option>
                <option value="m">{{ $t('form.kids.fld_sex_option_m') }}</option>
                <option value="?">{{ $t('form.kids.fld_sex_option_unknown') }}</option>
              </select>
            </div>

            <div class="form-item form-item-40" :class="{ hasError: showErrors && ( isRequiredByAge(kid) && !kid.firstname) }">
              <label class="small">{{ $t('form.kids.fld_firstname') }}<span v-if="isRequiredByAge(kid)" style="display:inline;"> *</span></label>
              <input
                :name="'kids.firstname_' + i"
                type="text"
                :required="isRequiredByAge(i)"
                  v-model="kid.firstname" v-on:blur="trySave()"/>
            </div>

            <div class="form-item form-item-40">
              <label>{{ $t('form.kids.fld_lastname') }}</label>
              <input
                :name="'kids.last_' + i"
                type="text"
                  v-model="kid.lastname" v-on:blur="trySave()"/>
            </div>
          </div>

          <div v-if="kids.length > 1 && !kidValid(kid)" class="buttonAlignRight">
            <button @click.prevent="removeKid(i)" class="btn-tertiary">{{ $t('form.kids.btn_cancel') }}</button>
          </div>

        </div>
          <div v-if="allValid" class="buttonAlignRight">
            <button name="addKid"
              class="btn-secondary"
              @click.prevent="addKid()">{{ $t('form.kids.btn_add_kid') }}</button>
          </div>
        <div v-if="!autoSave" id="submitOrBusy">
          <img v-if="axiosBusy" src="static/letsfamily-de/img/spinner.svg"/>
          <button v-else-if="!allValid" disabled>
              {{ $t('form.generic.btn_form_invalid') }}
            </button>
          <button name="updateKids" v-else
            class="form-submit"
            @click.prevent="updKids()">{{ $t('form.generic.btn_save') }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { getKids, updateKids } from "@/api/kids.js";
import { mapGetters } from "vuex";
import BirthdateField from "@/snippets/BirthdateField.vue";
import { parseISO, isBefore, subYears, addMonths, differenceInMonths } from "date-fns";

export default {
  name: "KidsForm",
  props: {
    autoSave: {
      type: Boolean,
      default: true
    },
    showErrors: {
      type: Boolean,
      default: false
    },
    skipValidation: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      kids: [],
      loaded: false,
      hasData: false
    };
  },
  computed: {
    ...mapGetters({
      axiosBusy: "axiosIsBusy"
    }),
    allValid: function() {
      let okKid = 0;
      this.kids.forEach(k => {
        if (this.kidValid(k)) {
          okKid++;
        }
      });
      if (this.kids.length == okKid) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    this.fetchData();
  },
  async beforeDestroy() {
    if (this.skipValidation) {
      await this.updKids();
    }
  },
  methods: {
    async fetchData() {
      const rv = await getKids(this.$userClient);
      if (rv) {
        this.kids = rv.kids;
        this.loaded = true;
        this.hasData = this.allValid;
      }
    },
    async trySave() {
      if (this.autoSave && this.allValid) {
        await this.updKids();
      }
    },
    async updKids() {
      const rv = await updateKids(this.$userClient, this.kids);
      if (rv) {
        this.kids = rv.kids;
        this.$emit("user-data-updated", {subform: "kids", "return": rv } );
      }
    },
    addKid() {
      this.kids.push({
        firstname: "",
        lastname: "",
        sex: "",
        birthdate: null
      });
    },
    async removeKid(i) {
      if (this.kids.length == 1) {
        this.kids[0].firstname = "";
        this.kids[0].lastname = "";
        this.kids[0].birthdate = null;
        this.kids[0].sex = "";
      } else {
        this.$delete(this.kids, i);
      }
      await this.updKids();
    },
    kidValid(kid) {
      if (kid.birthdate && this.birthdateError(kid) == false) {
        if (this.isRequiredByAge(kid)) {
          return kid.firstname !== null && kid.sex !== null ? true : false;
        }
        return true;
      }
      return false;
    },
    birthdateError(kid) {
      if (kid.birthdate === null) {
        // no date yet, so don't check for errors
        return false;
      }
      if (kid.birthdate) {
        const bd = parseISO(kid.birthdate);
        if (isBefore(addMonths(new Date(), 10), bd)) {
          return "kid_too_young";
        }
        if (isBefore(bd, subYears(new Date(), 18))) {
          return "kid_too_old";
        }
        return false;
      } else {
        return "invalid";
      }
    },
    isRequiredByAge(kid) {
      if (kid.birthdate === null) {
        return false;
      }
      if (kid.birthdate) {
        let bd = parseISO(kid.birthdate);
        return differenceInMonths(new Date(), bd) >= 1 ? true : false;
      }
      return false;
    }
  },
  components: {
    BirthdateField
  }
};
</script>
